export const IndicatorStates = {
  Default: 'active',
  Active: 'active',
  Disabled: 'disabled',
  Danger: 'danger',
} as const;
